import { IconGalleryShadow } from '../../../icon/IconGalleryShadow';
import { IconProductShadow } from '../../../icon/IconProductShadow';
import { IconPurchases } from '../../../icon/IconPurchases';
import { IconVideoShadow } from '../../../icon/IconVideoShadow';
import { PostUI } from '../../types';
import { GetPostCardGridIconsOptions } from '../typings';

export const getPostCardGridIcons = (post: PostUI, options: GetPostCardGridIconsOptions) => {
    const icons = [];
    const { withProductsPreview, withCheckout } = options;

    if (withCheckout) {
        icons.push({ Icon: IconPurchases, isCheckout: true });
    }

    if (post.content.length > 1) {
        icons.push({ Icon: IconGalleryShadow });
    }

    if (post.content[0].type === 'video') {
        icons.push({ Icon: IconVideoShadow });
    }

    if (post.products?.items.length > 0 && !withProductsPreview && !withCheckout) {
        icons.push({ Icon: IconProductShadow });
    }

    return icons;
};
